// indexedDBImages.js
const DB_NAME = "imageCache";
const STORE_NAME = "images";
const VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onerror = (e) => reject(e.target.error);
    req.onsuccess = (e) => resolve(e.target.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

export async function saveImageToIndexedDB(key, blob) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  tx.objectStore(STORE_NAME).put({ blob, lastAccessed: Date.now() }, key);
  db.close();
}

export async function getImageFromIndexedDB(key) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readonly");
  const req = tx.objectStore(STORE_NAME).get(key);
  return new Promise((resolve, reject) => {
    req.onsuccess = () => {
      const record = req.result;
      if (!record) return resolve(null);

      record.lastAccessed = Date.now();
      saveImageToIndexedDB(key, record.blob); // Update access time
      resolve(record.blob);
    };
    req.onerror = () => reject(req.error);
    tx.oncomplete = () => db.close();
  });
}

export async function cleanOldImages(days = 30) {
  const db = await openDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);
  const req = store.openCursor();
  const cutoff = Date.now() - days * 24 * 60 * 60 * 1000;

  req.onsuccess = (e) => {
    const cursor = e.target.result;
    if (cursor) {
      const { lastAccessed } = cursor.value || {};
      if (!lastAccessed || lastAccessed < cutoff) {
        store.delete(cursor.key);
      }
      cursor.continue();
    }
  };

  req.onerror = () => db.close();
  tx.oncomplete = () => db.close();
}







